import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * A list's filters in the URL, remembered for the session: coming back to the list without them
 * (a back link, the sidebar) restores the last ones. Only ``keys`` count as filters.
 */
export function useStickySearch(name: string, keys: string[]) {
  const [params, setParams] = useSearchParams()
  const storage = `list-filters:${name}`
  const filters = () => { const value = new URLSearchParams(); for (const key of keys) if (params.get(key)) value.set(key, params.get(key)!); return value }
  useEffect(() => {
    if (keys.some(key => params.get(key))) return
    let saved: string | null = null
    try { saved = sessionStorage.getItem(storage) } catch { /* storage unavailable: start unfiltered */ }
    if (!saved) return
    const next = new URLSearchParams(params)
    new URLSearchParams(saved).forEach((value, key) => next.set(key, value))
    setParams(next, { replace: true })
    // Only on arrival: later changes are the user's own.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    try { sessionStorage.setItem(storage, filters().toString()) } catch { /* storage unavailable */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])
  return [params, setParams] as const
}
